import {HANES_TAGLESS, HANES_ESSENTIAL} from './ProductConstants';

export const SIMPLE_PRICING_FLAG = 'simple_pricing_v7';
export const UPLOAD_ONE_COLOR_FLAG = 'uploadOneColor_v2';
export const UPLOAD_AUTO_SIZING_FLAG = 'upload_auto_sizing_v3';
export const WAYS_TO_ORDER_FLAG = 'ways_to_order_v9';
export const RETRIEVE_DESIGNS = 'retrieveDesigns_v2';
export const CI_HEADER_FLAG = 'ci_header_v1';
export const DRAG_N_DROP_ANYWHERE_FLAG = 'drag_n_drop_anywhere_v1';
export const ADD_TO_CLIPART_FLAG = 'add_to_clipart_v2';
export const UPLOAD_FILE_SIZE_FLAG = 'upload_file_size_v1';

export default {
  [RETRIEVE_DESIGNS]: {
    flags: {
      test: 1,
      control: 0,
      excluded: 0
    }
  },
  autoFitText: {
    flags: {
      test1: 0,
      test2: 0,
      test3: 0,
      test4: 0,
      test5: 0,
      test6: 0,
      control: 0,
      excluded: 1
    }
  },
  defaultBlank_v9: {
    flags: {
      [HANES_TAGLESS.flagName]: 0,
      [HANES_ESSENTIAL.flagName]: 0,
      excluded: 1
    }
  },
  embroiderySleeveStyles_v2: {
    flags: {
      test: 1,
      control: 0,
      excluded: 0
    }
  },
  singlesPricingMessage_v4: {
    flags: {
      test: 0,
      control: 0,
      excluded: 1
    }
  },
  uploadColorRemoval: {
    flags: {
      test: 0,
      control: 0,
      excluded: 1
    }
  },
  uploadCTA_v2: {
    flags: {
      test: 0,
      control: 0,
      excluded: 1
    }
  },
  uploadResolution_v3: {
    flags: {
      test: 0,
      control: 0,
      excluded: 1
    }
  },
  [UPLOAD_ONE_COLOR_FLAG]: {
    flags: {
      test: 1,
      control: 0,
      excluded: 0
    }
  },
  decoration_overrides_v1: {
    flags: {
      test: 1,
      control: 0,
      excluded: 0
    }
  },
  [SIMPLE_PRICING_FLAG]: {
    flags: {
      test: 0,
      control: 0,
      excluded: 1
    }
  },
  [UPLOAD_AUTO_SIZING_FLAG]: {
    flags: {
      test: 1,
      control: 0,
      excluded: 0
    }
  },
  [WAYS_TO_ORDER_FLAG]: {
    flags: {
      test: 0,
      control: 0,
      excluded: 1
    }
  },
  [CI_HEADER_FLAG]: {
    flags: {
      test: 0,
      control: 0,
      excluded: 1
    }
  },
  [DRAG_N_DROP_ANYWHERE_FLAG]: {
    flags: {
      // hint: remove react-dropzone dependency after rolling this out to 100%
      test: 0,
      control: 0,
      excluded: 1
    }
  },
  [ADD_TO_CLIPART_FLAG]: {
    flags: {
      test: 0.5,
      control: 0.5,
      excluded: 0
    }
  },
  [UPLOAD_FILE_SIZE_FLAG]: {
    flags: {
      test: 0,
      control: 0,
      excluded: 1
    }
  }
};
